import React, { useState } from "react";
import { ScaleLoader } from "react-spinners";
import { Modal } from "react-bootstrap";
import { AxiosPost } from "../../../../../context/UserContext";
import { pushNotify } from "../../../../../services/NotifyService";
import { useEffect } from "react";
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import Button from '@inovua/reactdatagrid-community/packages/Button';
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter'
import DateFilter from '@inovua/reactdatagrid-community/DateFilter'
import moment from "moment";
import CreatableSelect from 'react-select/creatable';
import * as XLSX from 'xlsx';

function PropertyLogsTable() {
    const [isLoading, setIsLoading] = useState(false);
    const [deleteModal, setDeleteModal] = useState({ show: false, id: null });
    const [crewLogs, setCrewLogs] = useState(null);
    const gridStyle = { height: 'calc(100vh - 16.5rem)', marginTop: 10 };
    const [gridRef, setGridRef] = useState(null)
    const initialFormData = { vendor: '', shoot_date: moment().format("YYYY-MM-DD"), in_time: '', out_time: '', remarks: '', department: '', designation: '' }
    const [formData, setFormData] = useState([initialFormData])
    const [customsl, setCustomSl] = useState('0')
    window.moment = moment
    const [isLoading2, setIsLoading2] = useState(false)
    const [departmentOptions, setDepartmentOptions] = useState([{ label: "Fetching please Wait...", value: "-1" }])
    const [designationOptions, setDesignationOptions] = useState([{ label: "Fetching please Wait...", value: "-1" }])
    const [vendorOptions, setVendorOptions] = useState([])
    const [uploadData, setUploadData] = useState(null)

    const filterValue = [
        { name: "num_row", operator: 'eq', type: 'number', value: null },
        { name: 'vendor', operator: 'startsWith', type: 'string', value: '' },
        { name: 'shoot_date', operator: 'after', type: 'date', value: '' },
        { name: 'in_time', operator: 'startsWith', type: 'string', value: null },
        { name: 'out_time', operator: 'startsWith', type: 'string', value: '' },
        { name: 'remarks', operator: 'startsWith', type: 'string', value: '' },
        { name: 'department', operator: 'startsWith', type: 'string', value: '' },
        { name: 'designation', operator: 'startsWith', type: 'string', value: '' },
    ];

    const columns = [
        { name: 'num_row', header: 'sl', type: 'number', minWidth: 200 },
        { name: 'vendor', header: 'Vendor Username', minWidth: 200 },
        { name: 'department', header: 'Department', minWidth: 200 },
        { name: 'designation', header: 'Designation', minWidth: 200 },
        {
            name: 'shoot_date', defaultFlex: 2, header: 'Shoot Date', minWidth: 200,
            dateFormat: 'YYYY-MM-DD',
            filterEditor: DateFilter,
        },
        { name: 'in_time', defaultFlex: 2, header: 'In Time', minWidth: 200 },
        { name: 'out_time', defaultFlex: 2, header: 'Out Time', minWidth: 200 },
        { name: 'remarks', defaultFlex: 2, header: 'Remarks', minWidth: 200 },
        {
            name: 'sl', defaultFlex: 2, header: 'Actions', minWidth: 200,
            render: ({ value }) =>
                <button className="btn btn-sharp" style={{ color: "red" }} onClick={() => showDeleteForm(value)}><i class="fas fa-trash-alt"></i></button>
        },
    ];

    const columns2 = [
        { name: 'vendor', header: 'Vendor Username', minWidth: 200 },
        { name: 'department', header: 'Department', minWidth: 200 },
        { name: 'designation', header: 'Designation', minWidth: 200 },
        { name: 'shoot_date', defaultFlex: 2, header: 'Shoot Date', minWidth: 200 },
        { name: 'in_time', defaultFlex: 2, header: 'In Time', minWidth: 200 },
        { name: 'out_time', defaultFlex: 2, header: 'Out Time', minWidth: 200 },
        { name: 'remarks', defaultFlex: 2, header: 'Remarks', minWidth: 200 },
    ]

    const updateCustomSl = (logs, date) => {
        let temp = 0
        logs.map((log) => {
            if (log.shoot_date == date && log.num_row > temp) {
                console.log(log.num_row)
                temp = parseInt(log.num_row)

            }
        })
        setCustomSl(temp)
    }

    const exportCSV = () => {
        const columns = gridRef.current.visibleColumns;

        const header = columns.map((c) => c.name).join(',');
        const rows = gridRef.current.data.map((data) => columns.map((c) => data[c.id]).join(','));

        const contents = [header].concat(rows).join('\n');
        const blob = new Blob([contents], { type: 'text/csv;charset=utf-8;' });

        downloadBlob(blob);
    };

    const downloadBlob = (blob, fileName = 'grid-data.csv') => {
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.position = 'absolute';
        link.style.visibility = 'hidden';

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    };

    const fetchDepartments = async () => {
        try {
            setIsLoading2(true);
            const data = await AxiosPost('fetch_department_options.php', formData);
            if (data.success) {
                setDepartmentOptions(data.options)
            }
            else {
                pushNotify("error", "Error", data.error)
            }
        } catch {
            pushNotify("error", "Error", "Server Error!")
        } finally {
            setIsLoading2(false)
        }
    }

    const fetchDesignations = async () => {
        try {
            setIsLoading2(true);
            const data = await AxiosPost('fetch_designation_options.php', formData);
            if (data.success) {
                setDesignationOptions(data.options)
            }
            else {
                pushNotify("error", "Error", data.error)
            }
        } catch {
            pushNotify("error", "Error", "Server Error!")
        } finally {
            setIsLoading2(false)
        }
    }

    useEffect(() => {
        fetchLogsData()
        fetchDepartments()
        fetchDesignations()
    }, [])

    const handleCreate4 = async (inputValue) => {
        try {
            setIsLoading2(true);
            const data = await AxiosPost('add_department_option.php', { name: inputValue });
            if (data.success) {
                await fetchDepartments()
            }
            else {
                pushNotify("error", "Error", data.error)
            }
        } catch {
            pushNotify("error", "Error", "Server Error!")
        } finally {
            setIsLoading2(false)
        }
    }
    const handleCreate5 = async (inputValue) => {
        try {
            setIsLoading2(true);
            const data = await AxiosPost('add_designation_option.php', { name: inputValue });
            if (data.success) {
                await fetchDesignations()
            }
            else {
                pushNotify("error", "Error", data.error)
            }
        } catch {
            pushNotify("error", "Error", "Server Error!")
        } finally {
            setIsLoading2(false)
        }
    }

    const fetchLogsData = async () => {
        setIsLoading(true);
        try {
            const data = await AxiosPost('fetch_crew_logs.php')
            if (data.success) {
                setCrewLogs(data.logs)
                updateCustomSl(data.logs, moment().format("YYYY-MM-DD"))
            }
            else pushNotify("error", "Error", data.error)
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const showDeleteForm = (index) => {
        setDeleteModal({ show: true, id: index });
    }

    const deleteItem = async () => {
        setIsLoading(true);
        try {
            const data = await AxiosPost('delete_crew_log.php', { sl: deleteModal.id })
            console.log(data);
            if (data.success) pushNotify('success', 'Success', 'Item Deleted Successfully');
            else pushNotify('error', 'Error', data.error);
            setDeleteModal({ show: false, id: null });
            await fetchLogsData();
            console.log(data);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const cancelDelete = () => {
        setDeleteModal({ show: false, id: null });
    }

    const onChangeHandler = (e, index) => {
        let old = [...formData]
        old[index] = { ...old[index], [e.target.name]: e.target.value }
        setFormData(old)
    }

    const addCrewLog = async (e) => {
        e.preventDefault()
        try {
            const data = await AxiosPost('add_crew_log.php', formData)
            console.log(data);
            if (data.success) {
                setFormData([initialFormData])
                await fetchLogsData()
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const removeRow = (i) => {
        let old = []
        formData.map((data, index) => index == i ? null : old.push(data))
        setFormData(old)
    }

    const datechangehandler = (e) => {
        let old = [...formData]
        old.map((data, index) => {
            old[index].shoot_date = e.target.value
        })
        setFormData(old)
    }

    const fetchVendorOptions = async () => {
        try {
            const data = await AxiosPost('fetch_vendor_options.php')
            console.log(data);
            if (data.success) {
                setVendorOptions(data.options)
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchVendorOptions()
    }, [])

    const handleUpload = (e) => {
        console.log("working")
        e.preventDefault()
        var files = e.target.files, f = files[0];
        const reader = new FileReader();
        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: 'binary' });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws, { header: ["sl", "shoot_date", "activity_type", "description", "quantity", "remarks"], blankrows: false, defval: '' });
            data.map((input, index) => {
                input.shoot_date = moment(input.shoot_date, "DD-MM-YYYY").format("YYYY-MM-DD")
            })
            data.shift()
            data.shift()
            console.log(data)
            setUploadData(data)
        };
        reader.readAsBinaryString(f);
    }

    const uploadExcelData = async () => {
        setIsLoading(true)
        try {
            const data = await AxiosPost('add_property_log_excel.php', uploadData)
            console.log(data);
            if (data.success) {
                await fetchLogsData()
                setUploadData(null)
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    return (
        <div className="col-lg-12 col-md-12 col-sm-12">
            <div>
                {
                    isLoading ? <ScaleLoader cssOverride={{ "display": "flex", "justifyContent": "center", "alignItems": "center" }} /> :
                        <>
                            <div>
                                <input className="form-control mb-2 mr-2" style={{ "width": "fit-content", display: "inline" }} type="file" onChange={handleUpload} id="demo" accept=".xls,.xlsx"></input>
                                <Button style={{ "margin-left": "10px" }} onClick={uploadExcelData}>
                                    Upload
                                </Button>
                                {uploadData == null ? null :
                                    <ReactDataGrid
                                        idProperty="id"
                                        style={gridStyle}
                                        columns={columns2}
                                        pagination="local"
                                        dataSource={uploadData}
                                        defaultLimit={25}
                                        handle={setGridRef}
                                        loading={isLoading}
                                    />
                                }
                            </div>
                            <form className='custom-form-wrapper mb-2' onSubmit={(e) => addCrewLog(e)}>
                                <div className="custom-form-inner">
                                    <div className='custom-form-cell'>
                                        <div className='custom-form-label'>
                                            Shoot Date <span className="text-danger">*</span>
                                        </div>
                                        <div className='custom-form-input'>
                                            <input type="date" value={formData[0].shoot_date} name="shoot_date" onChange={(e) => { datechangehandler(e); updateCustomSl(crewLogs, e.target.value) }} required />
                                        </div>
                                    </div>
                                </div>
                                {formData.map((data, index) => (
                                    <div className='custom-form-inner'>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Sl
                                                <button className="btn btn-primary tp-btn sharp custom-add-button" onClick={(e) => { e.preventDefault(); setFormData([...formData, initialFormData]) }} ><i className="fas fa-plus"></i></button>
                                                {index == 0 ? null : <button className="btn btn-primary tp-btn sharp custom-add-button" onClick={(e) => { e.preventDefault(); removeRow(index) }} ><i className="fas fa-minus"></i></button>}
                                            </div>
                                            <div className='custom-form-input'>
                                                <div className="form-control">{customsl + index + 1}</div>
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Vendor Username <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <CreatableSelect
                                                    onChange={(e) => { let old = [...formData]; old[index] = { ...old[index], "vendor": e }; setFormData(old) }}
                                                    options={vendorOptions}
                                                    value={formData[index].vendor}
                                                    isDisabled={isLoading2}
                                                    isLoading={isLoading2}
                                                    onCreateOption={(e) => { let temp = [...formData]; temp[index].vendor = { value: e, label: e }; setFormData(temp) }}
                                                />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>Department <span className='text-danger'>*</span></div>
                                            <div className='custom-form-input'>
                                                <CreatableSelect
                                                    onChange={(e) => { let old = [...formData]; old[index] = { ...old[index], "department": e }; setFormData(old) }}
                                                    options={departmentOptions}
                                                    value={formData[index].department}
                                                    isDisabled={isLoading2}
                                                    isLoading={isLoading2}
                                                    onCreateOption={(e) => { handleCreate4(e); let temp = [...formData]; temp[index].department = { value: e, label: e }; setFormData(temp) }}
                                                />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>Designation <span className='text-danger'>*</span></div>
                                            <div className='custom-form-input'>
                                                <CreatableSelect
                                                    onChange={(e) => { let old = [...formData]; old[index] = { ...old[index], "designation": e }; setFormData(old) }}
                                                    options={designationOptions}
                                                    value={formData[index].designation}
                                                    isDisabled={isLoading2}
                                                    isLoading={isLoading2}
                                                    onCreateOption={(e) => { handleCreate5(e); let temp = [...formData]; temp[index].designation = { value: e, label: e }; setFormData(temp) }}
                                                />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                In Time
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="time" value={formData[index].in_time} name="in_time" onChange={(e) => onChangeHandler(e, index)} />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Out Time
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="time" value={formData[index].out_time} name="out_time" onChange={(e) => onChangeHandler(e, index)} />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Remarks
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="text" value={formData[index].remarks} name="remarks" onChange={(e) => onChangeHandler(e, index)} />
                                            </div>
                                        </div>
                                    </div>))}
                                <Button className="mt-2 mb-2">
                                    Add Crew Log
                                </Button>
                            </form>
                        </>
                }

            </div>
            {
                isLoading || crewLogs == null ?
                    <ReactDataGrid
                        idProperty="id"
                        style={gridStyle}
                        columns={columns}
                        pagination="local"
                        dataSource={[]}
                        defaultLimit={10}
                        loading={true}
                    /> :
                    <>
                        <Button onClick={fetchLogsData}>
                            Sync Data
                        </Button>
                        <Button style={{ marginLeft: 10 }} onClick={exportCSV}>
                            Export CSV
                        </Button>
                        <ReactDataGrid
                            idProperty="id"
                            style={gridStyle}
                            columns={columns}
                            pagination="local"
                            dataSource={crewLogs}
                            defaultLimit={25}
                            defaultFilterValue={filterValue}
                            handle={setGridRef}
                        />
                    </>
            }
            <Modal className="fade" show={deleteModal.show} centered>
                <Modal.Header>
                    <Modal.Title>Delete Log?</Modal.Title>
                    <button
                        onClick={cancelDelete}
                        className="btn-close"
                    >
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4>Are you sure you want to delete the Log?</h4>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        onClick={deleteItem}
                        className="btn btn-danger"
                    >
                        Delete
                    </button>
                    <button className="btn btn-primary" onClick={cancelDelete}>Cancel</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
export default PropertyLogsTable;